import React from 'react';

export const HeartFlagIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                clipPath="url(#clip0)"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M.333 15.667V.333M.333 12.34l2.15-.66a6.552 6.552 0 015.36.681 6.552 6.552 0 005.233.72l2.035-.582a.767.767 0 00.557-.737V2.989a.767.767 0 00-.977-.737l-1.615.461a6.548 6.548 0 01-5.233-.72 6.553 6.553 0 00-5.361-.682l-2.149.662V12.34z" />
                <path d="M8 10.169L5.24 7.29a1.633 1.633 0 01-.307-1.888v0a1.633 1.633 0 012.615-.424L8 5.432l.45-.451a1.633 1.633 0 112.311 2.307L8 10.168z" />
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
